import { render, staticRenderFns } from "./price.vue?vue&type=template&id=584061b4&"
import script from "./price.vue?vue&type=script&lang=ts&"
export * from "./price.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('584061b4')) {
      api.createRecord('584061b4', component.options)
    } else {
      api.reload('584061b4', component.options)
    }
    module.hot.accept("./price.vue?vue&type=template&id=584061b4&", function () {
      api.rerender('584061b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/estates/price.vue"
export default component.exports